






























































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { AccountService } from "@/services/account.service";
import { ProposalsService } from "@/services/Proposals.service";
import { CouponsService } from "@/services//Coupons.service";
import { AdditionalOptionsService } from "@/services/AdditionalOptions.service";
import Number from "@/shared/filters/Number";
import { Utils } from "@/services/utils";
import { OsusumeDetailService } from "@/services/OsusumeDetail.service.ts";
import FilterSelectBox from "@/shared/mixins/FilterSelectBox";
@Component({
  filters: {
    Number
  },
  mixins: [FilterSelectBox]
})
export default class DialogMasterCopy extends Vue {
  @Prop() public masterType!: string;
  @Prop({ default: [] })
  public groupDataList!: any;

  @Prop() public groupCd!: string;
  @Prop() public shatenCd!: string;

  display: boolean = false;
  loading: boolean = false;
  accountService = new AccountService();
  proposalService = new ProposalsService();
  couponService = new CouponsService();
  tokutenService = new OsusumeDetailService();
  additionalOptionsService = new AdditionalOptionsService();

  shatenDataListFrom: any = [];
  kyotenDataListFrom: any = [];
  shatenDataListTo: any = [];
  kyotenDataListTo: any = [];
  disabledBtnCopy: boolean = true;
  listData: any = [];
  listSelected: number[] = [];

  baseFrom: any = {
    groupCd: "",
    shatenCd: "",
    kyotenCd: ""
  };

  baseTo: any = {
    groupCd: "",
    shatenCd: "",
    kyotenCd: ""
  };

  isNotAdmin: boolean = true;
  util: Utils = new Utils();
  checkAll: boolean = false;

  created() {
    const loginTypeKbn = localStorage.getItem("loginTypeKbn");
    if (loginTypeKbn === "1" || loginTypeKbn === "10") {
      this.isNotAdmin = false;
    }
  }

  validateCopy() {
    if (
      this.baseTo.groupCd &&
      this.baseTo.shatenCd &&
      this.baseTo.kyotenCd &&
      this.listSelected.length > 0
    ) {
      this.disabledBtnCopy = false;
    } else {
      this.disabledBtnCopy = true;
    }
  }

  open() {
    this.display = true;
    this.baseFrom = {
      groupCd: this.groupCd,
      shatenCd: this.shatenCd,
      kyotenCd: ""
    };

    this.baseTo = {
      groupCd: this.groupCd,
      shatenCd: this.shatenCd,
      kyotenCd: ""
    };
    if (this.groupCd === "") {
      this.$set(this, "shatenDataListFrom", []);
      this.$set(this, "shatenDataListTo", []);
      this.$set(this, "kyotenDataListFrom", []);
      this.$set(this, "kyotenDataListTo", []);
    } else if (
      (this.baseFrom.groupCd &&
        this.baseTo.groupCd &&
        this.baseFrom.groupCd != this.baseTo.groupCd) ||
      this.shatenDataListTo.length === 0
    ) {
      this.getShatenDataList(false).then(() => {
        this.$set(
          this,
          "shatenDataListTo",
          this.util.deepCopy(this.shatenDataListFrom)
        );
      });
      this.getKyotenDataList(false).then(() => {
        this.$set(
          this,
          "kyotenDataListTo",
          this.util.deepCopy(this.kyotenDataListFrom)
        );
      });
    }

    this.listData = [];
    this.listSelected = [];
    this.disabledBtnCopy = true;
  }

  getBase(isTo: boolean) {
    return isTo ? this.baseTo : this.baseFrom;
  }

  getDataKey(isTo: boolean) {
    return isTo ? "To" : "From";
  }

  clearData(isTo: boolean) {
    if (!isTo) {
      this.$set(this, "listData", []);
      this.$set(this, "listSelected", []);
      this.$set(this, "listSelected", []);
      this.$set(this, "disabledBtnCopy", true);
    }
  }

  async getShatenDataList(isTo: boolean) {
    let base: any = this.getBase(isTo);
    if (base.groupCd) {
      this.loading = true;
      const response = await this.accountService.getShatens(base.groupCd);
      let arr: any = [];
      if (response) {
        arr = response;
      }
      this.loading = false;
      this.$set(this, "shatenDataList" + this.getDataKey(isTo), arr);
    }
  }

  async getKyotenDataList(isTo: boolean) {
    let base: any = this.getBase(isTo);
    if (base.groupCd && base.shatenCd) {
      this.loading = true;
      const response = await this.accountService.getKyotens(
        base.groupCd,
        base.shatenCd
      );

      let arr: any = [];
      if (response) {
        arr = response;
      }
      this.loading = false;
      this.$set(this, "kyotenDataList" + this.getDataKey(isTo), arr);
    }
  }

  async selectGroup(isTo: boolean) {
    let base: any = this.getBase(isTo);
    base.shatenCd = "";
    base.kyotenCd = "";
    this.$set(this, "kyotenDataList" + this.getDataKey(isTo), []);
    this.clearData(isTo);

    this.getShatenDataList(isTo);
  }

  async selectShaten(isTo: boolean = false) {
    let base: any = this.getBase(isTo);
    base.kyotenCd = "";
    this.getKyotenDataList(isTo);
    this.clearData(isTo);
  }

  selectKyoten() {
    this.loading = true;
    let fn: any;
    this.listData = [];
    if (this.masterType === "proposal") {
      fn = this.proposalService.getProposals(this.baseFrom);
    } else if (this.masterType === "coupon") {
      fn = this.couponService.getCoupons(this.baseFrom);
    } else if (this.masterType === "tokuten") {
      fn = this.tokutenService.getTokuten(this.baseFrom);
    } else if (this.masterType === "additionalOptions") {
      fn = this.additionalOptionsService.getAdditionalOptions(this.baseFrom);
    }
    fn.then((res: any) => {
      this.loading = false;
      if (res) {
        this.listData = res;
      }
    });
  }

  onCheckAll(isCheck: boolean) {
    this.listSelected = [];
    if (isCheck) {
      for (let i = 0; i < this.listData.length; i++) {
        this.listSelected.push(i);
      }
    }
    this.validateCopy();
  }

  onCopy() {
    let list: any = [];
    let service: any;
    this.listSelected.forEach((index: number) => {
      let obj: any = { ...this.baseTo };
      if (this.masterType == "coupon") {
        service = this.couponService;
        obj.couponNm = this.listData[index].couponNm;
        obj.couponZn = this.listData[index].couponZn;
        obj.couponZk = this.listData[index].couponZk;
      } else if (this.masterType == "proposal") {
        service = this.proposalService;
        obj.proposalNm = this.listData[index].proposalNm;
      } else if (this.masterType == "tokuten") {
        service = this.tokutenService;
        obj.tokutenNm = this.listData[index].tokutenNm;
      } else if (this.masterType == "additionalOptions") {
        service = this.additionalOptionsService;
        obj.optionNm = this.listData[index].optionNm;
        obj.kingakuZn = this.listData[index].kingakuZn;
        obj.kingakuZk = this.listData[index].kingakuZk;
        obj.taxRate = this.listData[index].taxRate;
      }
      list.push(obj);
    });
    if (service) {
      service.cloneData(list).then((res: number) => {
        if (res == 200) {
          this.$message({
            message: "copy success",
            type: "success"
          });
        } else {
          this.$message({
            message: "エラー",
            type: "error"
          });
        }
      });
    }
  }

  onClose() {
    this.checkAll = false;
    this.display = false;
  }
}
